<template>
  <form id="loginForm" class="container-sm mt-5" style="max-width: 420px;" @submit.prevent="login">
    <h1 class="display-6 mb-4">Sign in</h1>
    <div class="form-floating mb-3">
      <input v-model="username" class="form-control" id="username" placeholder="username">
      <label for="username">Username</label>
    </div>
    <div class="form-floating mb-3">
      <input v-model="password" type="password" class="form-control" id="password" placeholder="••••••••">
      <label for="password">Password</label>
    </div>
    <button type="submit" class="btn btn-dark w-100">Continue</button>
  </form>
</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';

const username = ref('');
const password = ref('');
const router = useRouter();

// document.getElementById('username').addEventListener('keypress', function(event) {
//       if (event.key === 'Enter') {
//         event.preventDefault(); // Prevent default form submit
//         document.getElementById('loginForm').login(); // Trigger form submit
//       }
//     });

async function login() {
  try {
    if ('Notification' in window && Notification.permission === 'default') {
      try {
        await Notification.requestPermission();
      } catch (error) {
        console.warn('Notification permission request failed:', error);
      }
    }

    const BASE_URL = process.env.VUE_APP_API_URL;
    const response = await axios.post(`${BASE_URL}/login`, {
      username: username.value,
      password: password.value,
    });

    sessionStorage.setItem('token', response.data.token);
    const payload = JSON.parse(atob(response.data.token.split('.')[1]));
    sessionStorage.setItem('userType', payload.userType);
    sessionStorage.setItem('location', payload.location);

    axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

    if (payload.userType === 'admin' || payload.userType === 'authorizer') {
      router.push('/admin/fulfillment');
    } else {
      router.push('/overview/');
    }
  } catch (error) {
    console.error('Error during login:', error);
    alert('Login failed. Please try again.');
  }
}
</script>